export const OTP_TYPES = {
  SMS: {
    value: 'SMS',
    name: 'SMS'
  },
  WHATSAPP: {
    value: 'WHATSAPP',
    name: 'Whatsapp'
  }
};
